import {hasWindow, ROOT_HOSTNAMES} from '../src/common/constants'

export function determineDefaultHomepage(hostname) {
  // server side we should always pass in the hostname.
  // client side we can just get it from window.
  hostname = hostname || (hasWindow && window.location.hostname) || ''
  if (ROOT_HOSTNAMES.includes(hostname)) {
    return 'www'
  }
  return hostname.split('.')[0]
}
